import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrArrowDownIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.7857 4.22162C14.5001 3.9261 14.037 3.92613 13.7514 4.22168L8.00036 10.173L2.24855 4.22165C1.96293 3.92612 1.49984 3.92612 1.21422 4.22165C0.928594 4.51718 0.928594 4.99633 1.21422 5.29186L7.48322 11.7784C7.62039 11.9203 7.80643 12 8.00041 12C8.19439 12 8.38043 11.9203 8.51759 11.7783L14.7858 5.29183C15.0714 4.99628 15.0714 4.51713 14.7857 4.22162Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrArrowDownIconComponent;
